/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_ManagementInputs */

const en_data_management = /** @type {(inputs: Data_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Management`)
};

const nl_data_management = /** @type {(inputs: Data_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevensbeheer`)
};

/**
* | output |
* | --- |
* | "Data Management" |
*
* @param {Data_ManagementInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const data_management = /** @type {((inputs?: Data_ManagementInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_ManagementInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_data_management(inputs)
	return en_data_management(inputs)
});